import axios from 'axios'
const URL = process.env.REACT_APP_RAVEN_URL

export const login = (data) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'post',
      url: `${URL}/api/v1/user/login`,
      data: data,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error?.response)
    return error?.response
  }
}

export const register = (data) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'post',
      url: `${URL}/server/v1/_auth/register`,
      data: data,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const changePassword = (data) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'post',
      url: `${URL}/server/v1/_auth/change_password`,
      data: data,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const validateSession = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/user/validate-session`,
    })

    return res
  } catch (error) {
    console.log('Error')
    console.log()
    return error
  }
}

export const logoutAction = async () => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/user/logout`,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}

export const dispatchAlert = (type, title, message, show) => async (dispatch) => {
  dispatch({
    type: 'SWEET_ALERT',
    payload: {
      type: `${type}`,
      title: `${title}`,
      message: `${message}`,
    },
    show: show,
  })
}
